import { DocumentConnectionView } from "src/api/generated/postgres/db/types/documents/tables/documentConnectionView.ts";
import { CatalogPartRevisionView } from "src/api/generated/erp/db/types/tables/catalogPartRevisionView.ts";
import { CatalogPartRevisionDocumentConfigurationRuleApi } from "src/api/generated/erp/configurator/management/catalogPart/api/catalogPartRevisionDocumentConfigurationRuleApi.ts";
import { FormConfiguratorLuaEditor } from "src/components/views/erp/configurator/scripting/FormConfiguratorLuaEditor.tsx";
import { AsyncForm } from "src/components/common/forms/AsyncForm.tsx";
import { CatalogPartRevisionDocumentConfigurationRule } from "src/api/generated/erp/db/types/tables/catalogPartRevisionDocumentConfigurationRule.ts";
import { DeepPartial } from "react-hook-form";
import { CatalogPartRevisionUnrestrictedEditingWarning } from "../../../parts/catalogPart/CatalogPartRevisionUnrestrictedEditingWarning";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface CatalogPartRevisionDocumentConfigurationRulesViewProps {
	catalogPartRevision: CatalogPartRevisionView;
	document: DocumentConnectionView;
	onDirtyStateChanged?: (isDirty: boolean) => void;
}

interface FormValues {
	ruleScript: string;
}

export const CatalogPartRevisionDocumentConfigurationRulesView = (
	props: CatalogPartRevisionDocumentConfigurationRulesViewProps,
) => {
	const { catalogPartRevision, document, onDirtyStateChanged } = props;

	return (
		<AsyncForm
			fetch={() =>
				CatalogPartRevisionDocumentConfigurationRuleApi.getRevisionDocumentConfigurationRules({
					catalogPartRevisionId: catalogPartRevision.catalogPartRevisionId,
					documentId: document.documentId,
				})
			}
			getDefaultValues={getDefaultValues}
			submit={submit}
			onCompleted={() => onDirtyStateChanged?.(false)}
			onFormEdited={() => onDirtyStateChanged?.(true)}
			hideCancel
			agentContext={{
				key: defineAgentUiContextKey("erp.configurator.catalogPartRevisionDocumentConfigurationRules.form"),
				data: {
					catalogPartRevisionId: catalogPartRevision.catalogPartRevisionId,
					documentId: document.documentId,
				},
			}}
			getUseFormProps={() => ({
				disabled: catalogPartRevision.state === "DESIGNED" && !catalogPartRevision.unrestrictedEditingCascaded,
			})}
			render={({ control }) => (
				<VerticalBox sx={{ flex: 1 }}>
					<CatalogPartRevisionUnrestrictedEditingWarning revision={catalogPartRevision} />
					<FormConfiguratorLuaEditor
						control={control}
						name={"ruleScript"}
						catalogPartRevisionId={catalogPartRevision.catalogPartRevisionId}
						productFamilyVersionId={catalogPartRevision.configurationProductFamilyVersionId}
					/>
				</VerticalBox>
			)}
		/>
	);

	function getDefaultValues(initData: CatalogPartRevisionDocumentConfigurationRule | null): DeepPartial<FormValues> {
		return {
			ruleScript: initData?.ruleScript ?? "",
		};
	}

	async function submit({ ruleScript }: FormValues) {
		return await CatalogPartRevisionDocumentConfigurationRuleApi.setRevisionDocumentConfigurationRules({
			catalogPartRevisionId: catalogPartRevision.catalogPartRevisionId,
			documentId: document.documentId,
			ruleScript: ruleScript,
		});
	}
};
